import React from 'react'
import { Box, Button } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { ActuatorButton } from 'src/Libs/smart-home/models/smart-home.model'

const useStyles = makeStyles()(theme => ({
  buttonGroup: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 117px)',
    gridAutoRows: 'auto',
    gap: theme.spacing(1),
    width: '100%',

    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr 1fr',
    },
  },
  firstButton: {
    [theme.breakpoints.down('sm')]: {
      gridColumn: 1,
    },
  },
  lastButton: {
    [theme.breakpoints.down('sm')]: {
      gridColumn: 1,
      gridRow: 2,
    },
  },
  middleButton: {
    [theme.breakpoints.down('sm')]: {
      gridColumn: 2,
    },
  },
}))

interface Props {
  buttons: ActuatorButton[]
}

const ActuatorButtonGroup: React.FC<Props> = ({ buttons }) => {
  const { classes } = useStyles()

  return (
    <Box className={classes.buttonGroup}>
      {buttons.map((button, index) => (
        <Button
          key={`actuator-button-${button.label}`}
          className={index === 0 ? classes.firstButton : index === buttons.length - 1 ? classes.lastButton : classes.middleButton}
          onClick={button.onClick}
          variant={button.variant || 'contained'}
          data-qa={button.dataQa}
          startIcon={button.startIcon}
        >
          {button.label}
        </Button>
      ))}
    </Box>
  )
}

export default ActuatorButtonGroup
